import dayjs from "dayjs";
const ybRequestTemplate = {
    method: 'post',
    url: '/eapdomain/callService',
    host: '172.16.10.36:8889',
    headers: {
        hsf_signature: '',
        fixmedins_code: '',
        infosyscode: '',
        hsf_timestamp: dayjs().unix().toString(),
        hsf_nonce: generateRandomString(),
    },
    body: {
        infno: "",
        msgid: '',
        // mdtrtarea_admvs: '',
        insuplc_admdvs: "",
        recer_sys_code: "007",
        dev_no: "",
        dev_safe_info: "",
        cainfo: "",
        signtype: "SM3",  // SM3
        infver: '1.4.0',
        opter_type: "1",
        opter: '',
        opter_name: '',
        inf_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        fixmedins_code: '',
        fixmedins_name: '',
        sign_no: "",
        input: {
            
        }
    }
};
function generateRandomString(length = 32) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export { ybRequestTemplate };